/**
 * Will attemp to display the progress bar as Active
 *
 */
var progressBar = function(){

    var progress = setInterval(function() {

        var $bar = $('.progress-bar');

        // If smaller
        if ($bar.width()>=$bar.closest('.progress').width() ) {
            clearInterval(progress);
            $bar.removeClass('active');
        } else {
            $bar.width($bar.width()+40);
        }
    }, 100); }

// Register event for the Show Body Modal
$('body').on('show.bs.modal', '.modal#remote', progressBar);
